<template>
    <div class="Hback">
        <template v-if='type == 1'>
            <div class='banner1' :style="{background:'url('+require('../assets/'+url)+') #ffffff no-repeat center'}">
                <div class='b_l'>
                    <div><span v-if='text != ""' @click='visible = true'>{{text}}</span></div>
                    <div class='inputI'>
                        <div>获取数智化解决方案</div>
                        <div>
                            <div><span>*</span> 手机号</div>
                            <el-input class='inputt' placeholder='请输入手机号'></el-input>
                        </div>
                        <div>
                            <el-input class='inputt' placeholder='短信验证码'></el-input>
                            <div class='code'>获取验证码</div>
                        </div>
                        <div>
                            <el-checkbox v-model="checked">我已阅读并同意 <span>《隐私政策》</span></el-checkbox>
                        </div>
                        <div>确认提交</div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if='type == 2'>
            <div class='banner2' :style="{background:'url('+require('../assets/'+url)+') #ffffff no-repeat center'}">
                <div class='b_l'>
                    <div>
                        <p>{{title}}</p>
                        <span>{{content}}</span>
                        <div><span v-if='text != ""' @click='visible = true'>{{text}}</span></div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if='type == 3'>
            <div class='banner3'>
                <div class='b_l'>
                    <div>
                        <img :src="require('../assets/'+url)" />
                        <p>{{title}}</p>
                        <span>{{content}}</span>
                    </div>
                    <inputT top='140'></inputT>
                </div>
                <div class='pos'>
                    <div>
                        <div v-for='(item,index) in anchor' :key='index' @click='aClick(index)'>{{item}}</div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if='type == 4'>
            <div class='banner2 b3' :style="{background:'url('+require('../assets/'+url)+') #ffffff no-repeat center'}">
                <div class='b_l'>
                    <div>
                        <img :src="require('../assets/'+url2)" />
                        <p>{{title}}</p>
                        <span>{{content}}</span>
                        <div><span v-if='text != ""' @click='visible = true'>{{text}}</span></div>
                    </div>
                    <inputT></inputT>
                </div>
            </div>
        </template>

        <template v-if='type == 5'>
            <div class='banner2 b4' :style="{background:'url('+require('../assets/'+url)+') #ffffff no-repeat center'}">
                <div class='b_l'>
                    <div>
                        <p v-html='aaa1'></p>
                        <p v-html='title'></p>
                        <span>{{content}}</span>
                        <div v-if='text != ""'><span @click='visible = true'>{{text}}</span></div>
                        <v-el style='color:#757575;font-size:12px' v-html='bbb1'></v-el>
                    </div>
                    <inputT></inputT>
                </div>
            </div>
        </template>

        <Loding :visible.sync='visible'></Loding>
    </div>
</template>

<script>
export default {
    name: 'Hback',
    props:{
        // 什么类型得头部
        type: {
            type: [String,Number],
            default: 1
        },
        // 背景图
        url: {
            type: String,
            default: ''
        },
        // 按钮文字
        text: {
            type: String,
            default: '获取数智化解决方案'
        },
        // 背景图上展示的文字
        content: {
            type: String,
            default: ''
        },
        // 背景图上展示的标题
        title: {
            type: String,
            default: ''
        },
        // 跳转按钮
        anchor: {
            type: Array,
            default: []
        },
        // 弱智
        url2: {
            type: String,
            default: ''
        },
        aaa1:{
            type: String,
            default: ''
        },
        bbb1:{
            type: String,
            default: ''
        }

    },
    data() {
        return {
            visible: false,
        }
    },
    mounted() {
        console.log(this.aaa1)
    },
    methods:{
        // 锚点回调
        aClick(index) {
            this.$emit('aClick',index);
        },
    }
}
</script>

<style lang="scss" scoped>
    .Hback{
        .banner1,
        .banner2,
        .banner3,
        .banner4{
            width: 100%;
            position: relative;
            .b_l{
                width: 75rem;
                margin: 0 auto;
                overflow: hidden;
                animation: r 0.7s ease;
            }
        }

        .banner1{
            height: 40rem;
            background-size: auto 40rem !important;
            .b_l{
                display: flex;
                justify-content: space-between;
                >div:first-of-type{
                    width: 580px;
                    margin-top: 397px;
                    // float: left;
                    >span{
                        display: block;
                        width: 205px;
                        height: 46px;
                        line-height: 46px;
                        color: #ffffff;
                        font-size: 18px;
                        text-align: center;
                        background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
                        border-radius: 6px;
                        cursor: pointer;
                    }
                }
                // >div:last-of-type{
                //     float: right;
                //     margin-top: 120px;
                //     padding: 30px 30px;
                //     width: 357px;
                //     box-shadow: 0px 4px 8px 0px rgba(175, 175, 175, 0.1);
                //     border-radius: 6px;
                //     font-size: 14px;
                // }
            }
        }

        .banner2{
            height: 400px;
            background-size: auto 400px !important;
            .b_l{
                >div:nth-of-type(1){
                    padding-top: 64px;
                    >p{
                        font-size: 42px;
                        color: #E10013;
                        font-weight: 700;
                    }
                    >span{
                        display: block;
                        font-size: 16px;
                        color: #555;
                        line-height: 28px;
                        margin-top: 20px;
                        text-align: justify;
                    }
                    >div{
                        text-align: center;
                        line-height: 40px;
                        font-size: 16px;
                        color: #fff;
                        width: 128px;
                        height: 40px;
                        background: linear-gradient(0deg, #E60012 0%, #FF2638 99%);
                        border-radius: 4px;
                        margin-right: 16px;
                        margin-top: 24px;
                    }
                }
            }
        }

        .banner3{
            a{
                text-decoration:none;
                color: #4c4c4c;
            }
            height: 480px;
            background: #f7f8fa;
            overflow: hidden;
            .b_l{
                display: flex;
                justify-content: space-between;
                >div:nth-of-type(1) {
                    width: 580px;
                    margin-top: 54px;
                    >img{
                        height: 32px;
                    }
                    >p{
                        font-size: 36px;
                        color: #E31924;
                        margin-bottom: 28px;
                        font-weight: bold;
                    }
                    >span{
                        font-size: 14px;
                        line-height: 32px;
                        white-space: pre-wrap;
                        color: #333333;
                    }
                }
            }
            .pos{
                width: 100%;
                height: 60px;
                position: absolute;
                top: 406px;
                left: 0;
                background: #ffffff;
                border-bottom: 1px solid #d8d8d8;
                font-size: 16px;
                color: #333333;
                >div{
                    width: 75rem;
                    margin: 0 auto;
                    display: flex;
                    >div{
                        line-height: 54px;
                        margin-right: 35px;
                        cursor: pointer;
                    }
                    >div:nth-of-type(1){
                        border-bottom: 6px solid #e0060d;
                    }
                }
            }
        }

        .b3{
            height: 40rem;
            background-size: auto 40rem !important;
            overflow: hidden;
            .b_l{
                display: flex;
                justify-content: space-between;
                >div:nth-of-type(1) {
                    margin-top: 180px;
                    >img{
                        // width: 50px;
                        height: 25px;
                    }
                    >p{
                        font-size: 36px;
                        color: #E31924;
                        margin-bottom: 28px;
                        font-weight: bold;
                    }
                    >span{
                        font-size: 20px;
                        line-height: 32px;
                        white-space: pre-wrap;
                        color: #333333;
                    }
                    >div{
                        cursor: pointer;
                    }
                }
            }
        }

        .b4{
            height: 40rem;
            background-size: auto 40rem !important;
            overflow: hidden;
            >.b_l{
                display: flex;
                justify-content: space-between;
                >div:nth-of-type(1){
                    >p:nth-of-type(1){
                        font-size: 48px;
                        color: #cc0817;
                        margin-top: 80px;
                    }
                    >p:nth-of-type(2){
                        font-size: 30px;
                        color: #141414;
                        margin-top: 40px;
                    }
                    >span{
                        width: 500px;
                        display: inline-block;
                        font-size: 22px;
                        color: #333333;
                    }
                    >div:nth-of-type(1) {
                        display: block;
                        width: 220px;
                        height: 46px;
                        line-height: 46px;
                        color: #ffffff;
                        font-size: 18px;
                        text-align: center;
                        background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
                        border-radius: 6px;
                        margin: 40px 0;
                    }
                    >div:nth-of-type(2) {

                    }
                }
            }
        }

    }

    .inputI{
        /deep/ .el-input__inner{
            height: 30px!important;
        }
        /deep/ .el-checkbox__label{
            color: #333333 !important;
        }
        margin-top: 200px!important;
        transform: translatey(-30%);
        padding: 30px 30px;
        width: 360px;
        background: url(../assets/form-bg.png) #fff no-repeat top right;
        box-shadow: 0px 4px 8px 0px rgba(175, 175, 175, 0.1);
        border-radius: 6px;
        font-size: 14px;
        >div:nth-of-type(1) {
            line-height: 24px;
            font-size: 22px;
            color: #e61318;
            font-weight: 700;
            text-align: center;
            padding-bottom: 10px;
        }
        >div:nth-of-type(2) {
            display: flex;
            align-items: center;
            justify-content: space-between;
            >div{
                >span{
                    color: #e60012 !important;
                }
                font-size: 14px;
                color: #333333;
                line-height: 20px;
            }
            .inputt{
                width: 262px;
                height: 30px;
                margin-right: 26px;
            }
        }
        >div:nth-of-type(3) {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 10px;
            >.code{
                width: 106px;
                height: 30px;
                background: #e14c46;
                float: right;
                color: #fff;
                line-height: 50px;
                justify-content: center;
                align-items: center;
                display: flex;
                border-radius: 0 4px 4px 0;
                cursor: pointer;
                margin-right: 26px;
            }
            >.inputt{
                width: 158px;
                height: 30px;
            }
        }
        >div:nth-of-type(4) {
            margin-top: 26px;
            span{
                color: #e60012 !important;
            }
        }
        >div:nth-of-type(5) {
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            font-size: 16px;
            color: #ffffff;
            font-weight: 500;
            text-align: center;
            border: none;
            margin-top: 10px;
            background: #cc0817;
            cursor: pointer;
        }
    }
</style>
<style scoped>
@media all and (min-width: 980px) {
    .footer2{
        display: none !important;
    }
    .footer1{
        display: block !important;
    }
    .Hback{
        padding-top: 3%;
    }
    .Hback .banner2{
        width: 100%;
        padding-top: 3%;
    }
    .Hback .banner2 .b_l > div:nth-of-type(1) > span{
        width: 670px;
        max-width: 920px;
    }
    .Hback .banner3 .pos > div {
        width: 75rem;
    }
    .Hback .banner3{
        margin-top: 29px;
    }
}
@media all and (max-width: 980px) {
    .Hback .banner2{
        width: 94%;
        padding-left: 3%;
        padding-right: 3%;
    }
    .Hback .banner2 .b_l{
        width: 100% !important;
    }
    .Hback .banner2 .b_l > div:nth-of-type(1) > span{
        width: 92%;
        padding: 0 0 0 3%;
    }
    .Hback .banner2 .b_l > div:nth-of-type(1) > div{
        margin-left: 3%;
    }
    .Hback .banner3{
        width: 94%;
        padding: 3%;
    }
    .Hback .banner3 .pos > div {
        width: 100%;
        padding: 0 5%;
    }
    .Hback .banner3 .pos > div > div {
        margin-right: 18px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/banner.vue